import type { $Fetch } from 'ofetch';
import type { Boletim } from '@/domain/model/Boletim';
import type { BoletimGateway } from '@/application/port/out/BoletimGateway';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

/** FASE C.3 — gateway HTTP /api/v1/boletim?matriculaId={uuid}. */
export class HttpBoletimGateway implements BoletimGateway {
  constructor(private readonly client: $Fetch) {}

  async fetch(matriculaId: string): Promise<Boletim> {
    const res = await this.client<ApiResponse<Boletim>>('/api/v1/boletim', {
      method: 'GET', params: { matriculaId },
    });
    assertApiSuccess(res);
    return res.data;
  }
}
